// src/components/NavAccessProbe.jsx
import { useEffect } from "react";
import { useCognito } from "../utils/useCognito";

const API_BASE = "https://w6mxt54h5f.execute-api.us-east-2.amazonaws.com/Prod/api";

export default function NavAccessProbe() {
  const { getIdToken } = useCognito();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        if (!API_BASE) {
          console.warn("[NavAccessProbe] No API base configured (REACT_APP_ADMIN_API_URL). Skipping.");
          return;
        }
        const token = getIdToken();

        const res = await fetch(`${API_BASE}/nav`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();

        if (!cancelled) {
          console.log("%c[NavAccessProbe] allowed links:", "color:#7c3aed;font-weight:bold", data?.links || []);
        }
      } catch (e) {
        if (!cancelled) {
          console.error("[NavAccessProbe] failed to load /nav:", e);
        }
      }
    })();

    return () => { cancelled = true; };
  }, [getIdToken]);

  return null; // probe only
}
